<template>
    <div :class="getCSSClass('model-manager-details-container')">
        <div v-if="loading" v-html="loadingIndicator"></div>
        <template v-else>
            <div v-for="field in details"
                 :class="getCSSClass('model-manager-details-row')"
            >
                <div :class="getCSSClass('model-manager-details-column-first')">
                    <label v-html="field.label"></label>
                </div>
                <div :class="getCSSClass('model-manager-details-column-second')"
                     v-html="field.value"
                >
                </div>
            </div>
        </template>
        <div :class="getCSSClass('repository-manager-popup-buttons-container')"
        >
            <button type="button"
                    :class="getCSSClass('repository-manager-popup-cancel-button')"
                    v-on:click="$emit('canceled')"
                    v-html="icon('close')+this.translate('Bezár')"></button>
        </div>

    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            operationsUrl: {type: String},
            filename: {type: String},
        },
        data: function () {
            return {
                loading: true,
                details: null,
            }
        },
        mounted() {
            this.fetchDetails();
        },
        methods: {
            fetchDetails: function() {
                window.axios.post(this.operationsUrl, {operation: 'details', filename: this.filename})
                    .then((response) => {
                        this.details = response.data;
                        this.loading = false;
                    })
            },
        },
        computed: {},
        watch: {}

    }
</script>
